import React from 'react';

import Content from '@components/Dashboard/AdminPanel/Checkout';

const Checkout: React.FC = () => {
  return <Content />;
};

export default Checkout;
